import { Typography } from "@mui/material"
import { getAdvertiserDomainInStoreById } from "advertiser/tools/common"
import { translate } from "app/language/service"
import { IDspDealAdvertiserDomain } from "dsp-deal/model"
import React from "react"

interface IDspDealAdvertiserDomainsSummaryProps {
  advertiserDomains: IDspDealAdvertiserDomain[]
}

export const DspDealAdvertiserDomainsSummary = React.memo(
  ({ advertiserDomains }: IDspDealAdvertiserDomainsSummaryProps) => {
    if (advertiserDomains.length === 0) {
      return (
        <Typography id="summary-advertiser-domain-empty" color="textSecondary" fontSize=".85rem" sx={{ ml: "1rem" }}>
          {translate("label.n/a")}
        </Typography>
      )
    }
    return (
      <>
        {advertiserDomains.map((a, index) => {
          const advertiserDomain = getAdvertiserDomainInStoreById(a.advertiser_domain_id)
          let name = "-"
          if (advertiserDomain) {
            name = advertiserDomain.domain
          }
          return (
            <Typography
              id={`summary-advertiser-domain-${index}`}
              key={index}
              fontSize=".8rem"
              color="textPrimary"
              sx={{
                border: theme => theme.palette.border,
                p: ".3rem",
                pl: ".5rem",
                pr: ".5rem",
                borderRadius: ".125rem"
              }}>
              {name}
            </Typography>
          )
        })}
      </>
    )
  }
)
